import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { AuthService, StartupInfos_Auth } from './auth.service';
import { AuthenticatedDTO } from 'src/app/app.models';
import { RSAHelper } from 'src/app/shared/auth/rsa-helper';
import { environment } from 'src/environments/environment';
import sha256 from 'crypto-js/sha256';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

@Injectable()
export class AuthOnlineService extends AuthService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private _rsaHelper: RSAHelper,
        private _unitOfWork: UnitOfWorkOfflineDao,
    ) {
        super();
    }

    doAuthenticateAction(_username: string, _password: string): Promise<AuthenticatedDTO> {
        return new Promise((resolve, reject) => {
            this._httpClient.post<AuthenticatedDTO>(this._apiService.endPoints.Login, { username: this._rsaHelper.encryptWithPublicKey(_username), password: this._rsaHelper.encryptWithPublicKey(_password) })
            .subscribe((_response: AuthenticatedDTO) => {
                localStorage.setItem(environment.LS_ABWORKFLOW_CORE_API_AUTH_USERNAME, _username);
                localStorage.setItem(environment.LS_ABWORKFLOW_CODE_SOCIETE, _response.User.CODE_SOCIETE);
                localStorage.setItem(environment.LS_ABWORKFLOW_ENCRYPTED_PWD, JSON.stringify(sha256(_password).words));
                this.AuthSession = _response;
                this.authenticationState$.next(true);
                resolve(_response);
            }, (error) => {
                console.error(error);
                reject(!!error.error && !!error.error.Message ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur');
            });
        }) 
    }
    
    public doRefreshToken(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this._httpClient.post<AuthenticatedDTO>(this._apiService.endPoints.RefreshToken, { headers: { Authorization: 'Bearer ' + this.AuthSession.AccessToken } }, {})
            .subscribe(_response => {
                const session = this.AuthSession;
                session.RefreshToken = _response.RefreshToken;
                this.AuthSession = session;
                this.authenticationState$.next(true);
                resolve(true);
            }, (err) => {
                reject(err);
            });
        })
    }
    public doRenewExpiredPassword(_newPassword: string, _confirmPassword: string): Promise<any> {
        return new Promise((resolve, reject) => {
            _newPassword = this._rsaHelper.encryptWithPublicKey(_newPassword);
            _confirmPassword = this._rsaHelper.encryptWithPublicKey(_confirmPassword);

            this._httpClient.post(this._apiService.endPoints.RenewExpiredPassword, { 
                NewPassword: _newPassword, 
                ConfirmPassword: _confirmPassword 
            }).subscribe(_response => {
                localStorage.setItem(environment.LS_ABWORKFLOW_ENCRYPTED_PWD, JSON.stringify(sha256(_newPassword).words));
                resolve(_response);
            }, (err) => {
                reject(err);
            });
        });
    }

    public doRefreshStartupInfos(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this._httpClient.get<StartupInfos_Auth>(this._apiService.endPoints.doGetStartupInfosAction_Auth, { headers: { Authorization: 'Bearer ' + this.AuthSession.AccessToken } })
            .subscribe(_startupInfos => {
                this.pausedResponsesWorkflow$.next(_startupInfos.PAUSED_RESPONSES_WORKFLOWS);
                this.envVariables$.next(_startupInfos.VARIABLES_USER);
                this._unitOfWork.envVarUserDao.doSyncEnvironmentVariablesUserAction(_startupInfos.VARIABLES_USER);
                //this._unitOfWork.responseWorkflowDao.doSyncResponsesAction(_startupInfos.PAUSED_RESPONSES_WORKFLOWS);
                resolve();
            });
        });
    }

    public doVerifyPassword(_password: string): Promise<boolean> {
        return this._httpClient.post<boolean>(this._apiService.endPoints.VerifyPassword, { Password: _password }, { headers: { Authorization: 'Bearer ' + this.AuthSession.AccessToken } }).toPromise();
    }
}